<div class="toast-container-wrapper">
  <app-toast *ngFor="let toast of toasts$ | async" [toast]="toast" (remove)="removeToast($event)"></app-toast>
</div>
